/* =============================================================================
   REDEM MILANO — product.js
   Logica della pagina prodotto: galleria, varianti, aggiunta al carrello,
   costo per utilizzo. Vanilla ES6+, niente jQuery.
   ============================================================================= */

'use strict';

/* -----------------------------------------------------------------------------
   STATO GLOBALE DELLA PAGINA PRODOTTO
   Tiene traccia della variante selezionata e dell'indice dell'immagine attiva.
   ----------------------------------------------------------------------------- */
const _statoProdotto = {
  varianteCorrente:    null,   // Oggetto variante attualmente selezionato
  indiceImmagineAttiva: 0,     // Indice dell'immagine principale visualizzata
};

/* -----------------------------------------------------------------------------
   GALLERIA IMMAGINI — desktop
   Click sulle miniature per cambiare l'immagine principale con dissolvenza.
   ----------------------------------------------------------------------------- */
(function inizializzaGalleria() {
  const immagineMain     = document.querySelector('.product-gallery__main-image');
  const contenitoreMain  = document.querySelector('.product-gallery__main');
  const miniature        = document.querySelectorAll('.product-gallery__thumb');

  if (!immagineMain || miniature.length === 0) return;

  /**
   * Cambia l'immagine principale con animazione di dissolvenza.
   * @param {HTMLElement} miniatura - Miniatura cliccata
   * @param {number}      indice    - Indice dell'immagine nell'array
   */
  function mostraImmagine(miniatura, indice) {
    const srcNuovo = miniatura.dataset.src || miniatura.querySelector('img')?.src;
    const altNuovo = miniatura.dataset.alt || miniatura.querySelector('img')?.alt || '';
    if (!srcNuovo) return;

    // Rimuovi la classe attiva da tutte le miniature
    miniature.forEach((m) => m.classList.remove('is-active'));
    miniatura.classList.add('is-active');

    // Animazione opacità: 1 → 0 → 1
    immagineMain.style.opacity = '0';
    immagineMain.style.transition = 'opacity 0.25s ease';

    setTimeout(() => {
      immagineMain.src = srcNuovo;
      immagineMain.alt = altNuovo;
      _statoProdotto.indiceImmagineAttiva = indice;

      // Attende il caricamento prima di mostrare
      immagineMain.onload  = () => { immagineMain.style.opacity = '1'; };
      immagineMain.onerror = () => { immagineMain.style.opacity = '1'; }; // fallback sicuro
      // Se già in cache, forza l'opacity
      if (immagineMain.complete) immagineMain.style.opacity = '1';
    }, 250);
  }

  miniature.forEach((miniatura, indice) => {
    miniatura.addEventListener('click', () => mostraImmagine(miniatura, indice));

    // Supporto tastiera: Invio / Spazio
    miniatura.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        mostraImmagine(miniatura, indice);
      }
    });

    // Assicura accessibilità tastiera
    if (!miniatura.hasAttribute('tabindex')) miniatura.setAttribute('tabindex', '0');
  });

  // Imposta la prima miniatura come attiva al caricamento
  if (miniature[0]) miniature[0].classList.add('is-active');

  // Esponi per uso da altri moduli (es. selezione variante)
  window._galleriaModulo = { mostraImmagine, miniature };
})();

/* -----------------------------------------------------------------------------
   GALLERIA IMMAGINI — swipe mobile
   Supporto touch per scorrere tra le immagini con gesto di swipe.
   ----------------------------------------------------------------------------- */
(function inizializzaSwipeMobile() {
  const immagineMain = document.querySelector('.product-gallery__main-image');
  const miniature    = document.querySelectorAll('.product-gallery__thumb');
  if (!immagineMain || miniature.length === 0) return;

  // Soglia minima in pixel per riconoscere uno swipe
  const SOGLIA_SWIPE = 50;

  let touchInizioX = 0;
  let touchInizioY = 0;

  immagineMain.addEventListener('touchstart', (e) => {
    // Registra il punto di inizio del tocco
    touchInizioX = e.changedTouches[0].screenX;
    touchInizioY = e.changedTouches[0].screenY;
  }, { passive: true });

  immagineMain.addEventListener('touchend', (e) => {
    const deltaX = e.changedTouches[0].screenX - touchInizioX;
    const deltaY = e.changedTouches[0].screenY - touchInizioY;

    // Ignora se il movimento verticale è maggiore (scroll della pagina)
    if (Math.abs(deltaY) > Math.abs(deltaX)) return;
    // Ignora se lo swipe non raggiunge la soglia
    if (Math.abs(deltaX) < SOGLIA_SWIPE) return;

    const indiceAttuale = _statoProdotto.indiceImmagineAttiva;
    const totale        = miniature.length;
    let nuovoIndice;

    if (deltaX < 0) {
      // Swipe a sinistra → immagine successiva
      nuovoIndice = (indiceAttuale + 1) % totale;
    } else {
      // Swipe a destra → immagine precedente
      nuovoIndice = (indiceAttuale - 1 + totale) % totale;
    }

    const miniaturaNuova = miniature[nuovoIndice];
    if (miniaturaNuova && window._galleriaModulo) {
      window._galleriaModulo.mostraImmagine(miniaturaNuova, nuovoIndice);
    }
  }, { passive: true });
})();

/* -----------------------------------------------------------------------------
   SELETTORE VARIANTI — swatches colore / materiale
   Aggiorna il DOM quando l'utente seleziona una variante diversa.
   ----------------------------------------------------------------------------- */
(function inizializzaVarianti() {
  const swatches          = document.querySelectorAll('.swatch[data-variant-id]');
  const elementoPrezzo    = document.querySelector('.product-info__price');
  const btnAtc            = document.getElementById('product-atc-btn');

  if (swatches.length === 0) return;

  // window.productVariants è impostato dal template Liquid del prodotto
  const varianti = window.productVariants || [];

  /**
   * Trova un oggetto variante per ID nell'array globale.
   * @param {string|number} id - ID variante
   * @returns {Object|undefined}
   */
  function trovaVariante(id) {
    return varianti.find((v) => String(v.id) === String(id));
  }

  /**
   * Aggiorna l'URL della pagina con il parametro ?variant=ID
   * senza ricaricare la pagina.
   * @param {string|number} variantId
   */
  function aggiornaUrl(variantId) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    history.replaceState({ variantId }, '', url.toString());
  }

  /**
   * Aggiorna la galleria per mostrare l'immagine associata alla variante.
   * @param {Object} variante - Oggetto variante Shopify
   */
  function aggiornaGalleriaVariante(variante) {
    if (!variante.featured_image || !window._galleriaModulo) return;

    const srcVariante = variante.featured_image.src;
    const miniature   = window._galleriaModulo.miniature;

    // Cerca la miniatura che corrisponde all'immagine della variante
    miniature.forEach((miniatura, indice) => {
      const srcMiniatura = miniatura.dataset.src || miniatura.querySelector('img')?.src || '';
      // Confronto parziale dell'URL (Shopify aggiunge dimensioni al nome file)
      if (srcMiniatura.includes(variante.featured_image.src.split('?')[0].split('/').pop().split('_')[0])) {
        window._galleriaModulo.mostraImmagine(miniatura, indice);
      }
    });
  }

  /**
   * Applica le modifiche al DOM per la variante selezionata.
   * @param {Object} variante
   */
  function applicaVariante(variante) {
    _statoProdotto.varianteCorrente = variante;

    // Aggiorna il prezzo
    if (elementoPrezzo) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        // Prezzo in saldo: mostra sia il prezzo scontato sia quello originale
        elementoPrezzo.innerHTML = '';
        const prezzoScontato = document.createElement('span');
        prezzoScontato.className   = 'price price--sale';
        prezzoScontato.textContent = _formattaValuta(variante.price);

        const prezzoOriginale = document.createElement('s');
        prezzoOriginale.className   = 'price price--compare';
        prezzoOriginale.textContent = _formattaValuta(variante.compare_at_price);

        elementoPrezzo.append(prezzoScontato, prezzoOriginale);
      } else {
        elementoPrezzo.textContent = _formattaValuta(variante.price);
      }
    }

    // Disponibilità: abilita/disabilita il pulsante ATC
    if (btnAtc) {
      const disponibile = variante.available;
      btnAtc.disabled    = !disponibile;
      btnAtc.dataset.variantId = variante.id;

      const labelBtn = btnAtc.querySelector('.btn__label') || btnAtc;
      if (disponibile) {
        labelBtn.textContent = window.themeStrings?.addToCart || 'Aggiungi al carrello';
        btnAtc.classList.remove('btn--sold-out');
      } else {
        labelBtn.textContent = window.themeStrings?.soldOut || 'Esaurito';
        btnAtc.classList.add('btn--sold-out');
      }
    }

    // Aggiorna URL
    aggiornaUrl(variante.id);

    // Aggiorna la galleria con l'immagine della variante
    aggiornaGalleriaVariante(variante);

    // Aggiorna il calcolo costo-per-utilizzo
    aggiornaCostoPerUtilizzo(variante.price);
  }

  // Collega i click sugli swatch
  swatches.forEach((swatch) => {
    swatch.addEventListener('click', () => {
      const variantId = swatch.dataset.variantId;
      const variante  = trovaVariante(variantId);
      if (!variante) return;

      // Aggiorna lo stato visivo degli swatch
      swatches.forEach((s) => {
        s.classList.remove('is-active');
        s.setAttribute('aria-checked', 'false');
      });
      swatch.classList.add('is-active');
      swatch.setAttribute('aria-checked', 'true');

      applicaVariante(variante);
    });
  });

  // Imposta la variante iniziale dal parametro URL o dal primo swatch disponibile
  const urlParams    = new URLSearchParams(window.location.search);
  const variantUrlId = urlParams.get('variant');
  const varianteIniziale =
    (variantUrlId && trovaVariante(variantUrlId)) ||
    trovaVariante(swatches[0]?.dataset.variantId);

  if (varianteIniziale) {
    _statoProdotto.varianteCorrente = varianteIniziale;
    // Marca lo swatch corrispondente come attivo
    const swatchIniziale = document.querySelector(
      `.swatch[data-variant-id="${varianteIniziale.id}"]`
    );
    if (swatchIniziale) {
      swatchIniziale.classList.add('is-active');
      swatchIniziale.setAttribute('aria-checked', 'true');
    }
    // Inizializza il bottone ATC
    if (btnAtc) btnAtc.dataset.variantId = varianteIniziale.id;
  }
})();

/* -----------------------------------------------------------------------------
   QUANTITÀ PRODOTTO — input +/−
   Gestisce i controlli di quantità prima dell'aggiunta al carrello.
   ----------------------------------------------------------------------------- */
(function inizializzaControlloQuantita() {
  const inputQta  = document.getElementById('product-qty');
  if (!inputQta) return;

  const btnMeno   = inputQta.previousElementSibling;
  const btnPiu    = inputQta.nextElementSibling;
  const qtaMin    = parseInt(inputQta.min, 10) || 1;
  const qtaMax    = parseInt(inputQta.max, 10) || 999;

  if (btnMeno) {
    btnMeno.addEventListener('click', () => {
      const val = parseInt(inputQta.value, 10);
      if (val > qtaMin) inputQta.value = val - 1;
    });
  }

  if (btnPiu) {
    btnPiu.addEventListener('click', () => {
      const val = parseInt(inputQta.value, 10);
      if (val < qtaMax) inputQta.value = val + 1;
    });
  }

  // Sanitizza l'input manuale
  inputQta.addEventListener('change', () => {
    let val = parseInt(inputQta.value, 10);
    if (isNaN(val) || val < qtaMin) val = qtaMin;
    if (val > qtaMax) val = qtaMax;
    inputQta.value = val;
  });
})();

/* -----------------------------------------------------------------------------
   AGGIUNTA AL CARRELLO — pulsante ATC principale
   Chiama RedemCart.addItem, mostra stato di caricamento e feedback visivo.
   ----------------------------------------------------------------------------- */
(function inizializzaAggiungiAlCarrello() {
  const btnAtc   = document.getElementById('product-atc-btn');
  const inputQta = document.getElementById('product-qty');
  if (!btnAtc) return;

  btnAtc.addEventListener('click', async () => {
    // Recupera la variante e la quantità correnti
    const variantId = btnAtc.dataset.variantId ||
                      _statoProdotto.varianteCorrente?.id;
    const quantita  = inputQta ? parseInt(inputQta.value, 10) : 1;

    if (!variantId) {
      console.warn('Nessuna variante selezionata');
      return;
    }

    // Stato di caricamento: disabilita il bottone e mostra indicatore
    btnAtc.disabled    = true;
    btnAtc.classList.add('is-loading');
    const labelBtn     = btnAtc.querySelector('.btn__label') || btnAtc;
    const testoOriginale = labelBtn.textContent;
    labelBtn.textContent = window.themeStrings?.adding || 'Aggiungendo...';

    try {
      // Aggiunge al carrello tramite l'API
      const carrello = await window.RedemCart.addItem(variantId, quantita);

      // Aggiorna il drawer con i nuovi dati
      if (typeof window.renderCartDrawer === 'function') {
        window.renderCartDrawer(carrello);
      }

      // Apre il drawer del carrello
      if (window.RedemDrawer && typeof window.RedemDrawer.apri === 'function') {
        window.RedemDrawer.apri();
      }

      // Informa gli altri moduli dell'aggiunta
      document.dispatchEvent(new CustomEvent('cart:add', {
        detail: { carrello, variantId, quantita },
        bubbles: true,
      }));

      // Mostra notifica toast di conferma
      if (typeof window.showToast === 'function') {
        window.showToast(window.themeStrings?.addedToCart || 'Aggiunto al carrello');
      }

      // Ripristina il testo del bottone dopo breve pausa
      labelBtn.textContent = window.themeStrings?.added || 'Aggiunto ✓';
      setTimeout(() => {
        labelBtn.textContent = testoOriginale;
        btnAtc.disabled      = false;
        btnAtc.classList.remove('is-loading');
      }, 1500);

    } catch (errore) {
      console.error('Errore aggiunta al carrello:', errore);

      // Mostra messaggio di errore all'utente
      if (typeof window.showToast === 'function') {
        window.showToast(errore.message || (window.themeStrings?.cartError || 'Errore. Riprova.'));
      }

      // Ripristina il bottone
      labelBtn.textContent = testoOriginale;
      btnAtc.disabled      = false;
      btnAtc.classList.remove('is-loading');
    }
  });
})();

/* -----------------------------------------------------------------------------
   COSTO PER UTILIZZO
   Calcola e mostra il costo giornaliero stimato dell'articolo in base
   al prezzo e agli anni di utilizzo previsti.
   ----------------------------------------------------------------------------- */
/**
 * Aggiorna l'elemento #product-cpu-price con il costo per utilizzo giornaliero.
 * Formula: (prezzo in euro) / (anni * 365)
 * @param {number} prezzoInCentesimi - Prezzo della variante selezionata
 */
function aggiornaCostoPerUtilizzo(prezzoInCentesimi) {
  const elementoCpu    = document.querySelector('.product-cpu');
  const elementoPrezzo = document.getElementById('product-cpu-price');
  if (!elementoCpu || !elementoPrezzo) return;

  // Leggi gli anni di utilizzo dal dataset dell'elemento (default: 10 anni)
  const anni = parseInt(elementoCpu.dataset.years, 10) || 10;

  // Calcolo: prezzo in euro / (anni * 365 giorni)
  const prezzoEuro      = prezzoInCentesimi / 100;
  const costoPerGiorno = prezzoEuro / (anni * 365);

  // Formatta con 2 decimali e il simbolo valuta
  elementoPrezzo.textContent = `€ ${costoPerGiorno.toFixed(2).replace('.', ',')}`;
}

(function inizializzaCostoPerUtilizzo() {
  const elementoCpu = document.querySelector('.product-cpu');
  if (!elementoCpu) return;

  // Calcola il costo iniziale con la variante corrente
  const varianteIniziale = _statoProdotto.varianteCorrente;
  if (varianteIniziale) {
    aggiornaCostoPerUtilizzo(varianteIniziale.price);
  } else if (window.productVariants && window.productVariants.length > 0) {
    aggiornaCostoPerUtilizzo(window.productVariants[0].price);
  }
})();

/* -----------------------------------------------------------------------------
   ACCORDION — delega al modulo in theme.js se già caricato
   Inizializza gli accordion specifici della pagina prodotto.
   ----------------------------------------------------------------------------- */
(function inizializzaAccordionProdotto() {
  const contenitoreProdotto = document.querySelector('.product-info');
  if (!contenitoreProdotto) return;

  if (typeof window.inizializzaAccordionIn === 'function') {
    // Usa il modulo condiviso di theme.js
    window.inizializzaAccordionIn(contenitoreProdotto);
  } else {
    // Fallback autonomo se theme.js non è ancora caricato
    contenitoreProdotto.querySelectorAll('.accordion__trigger').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const espanso  = trigger.getAttribute('aria-expanded') === 'true';
        const pannello = trigger.nextElementSibling;
        if (!pannello) return;
        trigger.setAttribute('aria-expanded', String(!espanso));
        pannello.hidden = espanso;
      });
    });
  }
})();

/* -----------------------------------------------------------------------------
   UTILITÀ INTERNA — formattazione valuta
   ----------------------------------------------------------------------------- */
/**
 * Formatta i centesimi come stringa in euro.
 * @param {number} centesimi
 * @returns {string}
 */
function _formattaValuta(centesimi) {
  if (typeof window.formatMoney === 'function') return window.formatMoney(centesimi);
  const formato = window.moneyFormat || '€{{amount}}';
  const importo = (centesimi / 100).toFixed(2).replace('.', ',');
  return formato.replace('{{amount}}', importo);
}
